import { useTranslation } from "react-i18next";

import { DealerComparisonPricesPayload } from "../../queries/useGetDealerComparisonPricesByTireSize";

type Option = {
  disabled: boolean;
  label: string;
  value: string;
};

export const useSeasons = (
  data: DealerComparisonPricesPayload = []
): Option[] => {
  const { t } = useTranslation();
  const options: Record<string, number> = {
    "0": 0,
    "2": 0,
  };

  for (const { season } of data) {
    if (season in options) {
      options[season] = options[season] + 1;
    }
  }

  const result = Object.entries(options).map(([value, count]) => ({
    disabled: count === 0,
    label: t(`season.${value}`),
    value,
  }));

  return result;
};
